export default __webpack_public_path__ + "4082bf9bf117dd7bfd6ddce0bf9d4d28.png";